import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const YearSelector = (props: any) => {
    const { value, manageSelect, isReadOnly } = props;
    const valueDate:any = value ? new Date(String(value)) : null;
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
            views={['year']}
            label=""
            value={dayjs(valueDate)}
            onChange={manageSelect}
            slotProps={{
                textField: {
                    variant: 'standard',
                    error: false,
                    disabled: isReadOnly
                },
            }}
            />
        </LocalizationProvider>
    )
}

export default YearSelector;